import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import messages from 'store/app/entities/messages/action';

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  actions: {
    messages: bindActionCreators(messages, dispatch),
  },
});

export default connect(mapStateToProps, mapDispatchToProps);
